import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { HtmlInclude } from '../../components/common/html-include/HtmlInclude';
import { useABTest } from '../../hooks/useABTest';
const ABTestingContainer = ({ abTestingCookieName, componentA, componentB, }) => {
    const { hasBCookie: ABTestEnabled } = useABTest(abTestingCookieName);
    return (_jsx(_Fragment, { children: !ABTestEnabled ? (_jsx(HtmlInclude, { htmlFragment: decodeURIComponent(componentA.renderedHTML) })) : (_jsx(HtmlInclude, { htmlFragment: decodeURIComponent(componentB.renderedHTML) })) }));
};
export default ABTestingContainer;
